import $ from 'jquery';

// function reset animate
function resetAnimate(paramClass, delClass, addClass) {
  return $(`.${paramClass} .${delClass}`).removeClass(delClass).addClass(addClass);
}

// function animate in
function inAnimate() {
  resetAnimate('active', 'a-move-out-1', 'a-move-in-1');
  resetAnimate('active', 'a-move-out-2', 'a-move-in-2');
  resetAnimate('active', 'a-move-out-3', 'a-move-in-3');
}

// function animate out
function outAnimate() {
  resetAnimate('active', 'a-move-in-1', 'a-move-out-1');
  resetAnimate('active', 'a-move-in-2', 'a-move-out-2');
  resetAnimate('active', 'a-move-in-3', 'a-move-out-3');
}

// manual animate out for first element
setTimeout(outAnimate,5000);

// change row every 5 second (8row x 5second = 40second)
setInterval(function() {
  // set display on to next row
  $('.js-home.active').removeClass('active').next().addClass('active');
  // animate in
  inAnimate();
  // animate out after 5 second
  setTimeout(outAnimate,5000);
},7700);

// reset animate after 61.6 second
setInterval(function() {
  // add active class to the first row
  $('.js-home:first').addClass('active');
  // animate in
  inAnimate();
},61600);